import React from 'react';

import { getColors } from '@styles/colorsTheme';
import { CloseOutlined } from '@material-ui/icons';
import { Grid, useTheme, useMediaQuery } from '@material-ui/core';

import '@styles/AntStyles.css';

const Termo: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function handleModalClose() {
    window.location.reload();
  }

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#0085BE',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isMobile ? '20px 10px' : '45px',
        boxSizing: 'border-box',
      }}
    >
      {/* --- MODAL PRINCIPAL --- */}
      <div
        style={{
          width: '100%',
          maxWidth: '1350px',
          minHeight: isMobile ? 'auto' : '700px',
          backgroundColor: '#FFF',
          borderRadius: isMobile ? '25px' : '35px',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
        }}
      >
        {/* --- BOTÃO FECHAR --- */}
        <button
          onClick={handleModalClose}
          style={{
            position: 'absolute',
            right: isMobile ? '18px' : '25px',
            top: isMobile ? '18px' : '25px',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: '#FFF',
            boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 20,
          }}
        >
          <CloseOutlined
            fontSize="medium"
            htmlColor={getColors()?.azulEscuro || '#1261A2'}
          />
        </button>

        <Grid
  container
  style={{
    minHeight: isMobile ? 'auto' : '700px',
    height: isMobile ? 'auto' : '700px',
  }}
>
          {/* ------- LADO IMAGENS ------ */}
          <Grid
            item
            xs={12}
            md={4}
            style={{
              position: 'relative',
              minHeight: isMobile ? '300px' : '700px',
              height: isMobile ? '300px' : '700px',              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              paddingTop: isMobile ? '20px' : '25px',
              overflow: 'hidden',
            }}
          >
            {/* LOGO */}
            <div
              style={{
                position: 'relative',
                zIndex: 5,
                width: isMobile ? '100px' : '145px',
                height: isMobile ? '100px' : '145px',
              }}
            >
              <img
                src="https://amex-osid.s3.sa-east-1.amazonaws.com/osid-aqsm-logo_1_parafundobranco.png"
                alt="OSID"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>

            {/* LOGO IRMÃ DULCE */}
            <div
  style={{
    position: 'absolute',
    left: isMobile ? '50%' : '20px',
    bottom: isMobile ? '-70px' : '15px',
    transform: isMobile ? 'translateX(-50%)' : 'none',
    width: isMobile ? '320px' : '480px',
    height: isMobile ? '320px' : '520px',

    backgroundImage:
      "url('https://crm-clickdobem.s3.sa-east-1.amazonaws.com/OSID/osidpng.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
  }}
/>
            {/* BORDA AMARELA DO CORAÇÃO */}

          </Grid>

          {/* =====================================================
              COLUNA DIREITA
          ====================================================== */}
          <Grid
            item
            xs={12}
            md={8}
            style={{
              padding: isMobile
              ? '15px 25px 25px'
              : '45px 55px 25px 35px',              boxSizing: 'border-box',
            }}
          >
            {/* TÍTULO */}
            <div
              style={{
                marginTop: isMobile ? '10px' : '5px',
                marginBottom: '12px',
                paddingRight: isMobile ? '35px' : '60px',
              }}
            >
              <div
                style={{
                  color: '#F1B63D',
                  fontWeight: 700,
                  fontSize: isMobile ? '28px' : '45px',
                  lineHeight: 1.05,
                  fontFamily: 'Arial, sans-serif',
                }}
              >
                Faça parte do
              </div>

              <div
                style={{
                  color: '#1261A2',
                  fontWeight: 800,
                  fontSize: isMobile ? '30px' : '48px',
                  lineHeight: 1.05,
                  fontFamily: 'Arial, sans-serif',
                }}
              >
                Clube do Sócio-Protetor!
              </div>

              {/* LINHA */}
              <div
                style={{
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#EAB638',
                  marginTop: '15px',
                  position: 'relative',
                }}
              >

              </div>
            </div>

            {/* TEXTOS */}
            <div
              style={{
                color: '#333',
                fontFamily: 'Arial, sans-serif',
                fontSize: isMobile ? '15px' : '19px',
                lineHeight: 1.45,
                marginTop: '25px',
              }}
            >
              <p style={{ marginBottom: '18px' }}>
                Ao se tornar um{' '}
                <strong style={{ color: '#1261A2' }}>
                  Sócio-Protetor
                </strong>
                , você contribui mensalmente para que as{' '}
                <strong style={{ color: '#1261A2' }}> Obras Sociais Irmã Dulce</strong> continuem
                transformando vidas e cuidando de quem mais precisa.
                Ser um{' '}
                <strong style={{ color: '#1261A2' }}>
                  Sócio-Protetor
                </strong>{' '}
                é muito mais do que fazer uma doação: é assumir o compromisso
                de estar ao lado das Obras Sociais Irmã Dulce todos os meses, ajudando a manter vivo
                um trabalho de amor, cuidado e solidariedade.
              </p>


            </div>

            {/* --- BENEFÍCIOS --- */}
            <div
              style={{
                border: '1px solid #E1E5EA',
                borderRadius: '22px',
                overflow: 'hidden',
                marginTop: '10px',
                backgroundColor: '#FFF',
                boxShadow: '0 3px 15px rgba(0,0,0,0.03)',
              }}
            >
              {/* CABEÇALHO DO CARD */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  color: '#1261A2',
                  fontWeight: 700,
                  fontSize: isMobile ? '16px' : '21px',
                  padding: '13px 15px',
                  textAlign: 'center',
                  borderBottom: '1px solid #EEF0F3',
                }}
              >
                <span>
                  Com a sua doação recorrente, você ajuda a:
                </span>
              </div>

              {/* ITEM 1 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  padding: '12px 20px',
                  borderBottom: '1px solid #EEF0F3',
                }}
              >
                <div style={iconStyle}>
                <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="12"
      //fill="#EDF6FD"
    />

    <path
      d="M24 36L21.8 34C14 27.2 10 23.5 10 18.5C10 14.6 13.1 12 16.8 12C19.1 12 21.5 13.1 24 15.6C26.5 13.1 28.9 12 31.2 12C34.9 12 38 14.6 38 18.5C38 23.5 34 27.2 26.2 34L24 36Z"
      stroke="#1261A2"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
                </div>

                <div style={textStyle}>
                  Garantir que <strong>mais pessoas</strong> sejam assistidas;
                </div>
              </div>

              {/* ITEM 2 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  padding: '12px 20px',
                  borderBottom: '1px solid #EEF0F3',
                }}
              >
                <div style={iconStyle}>
                <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="12" />

    <rect
      x="11"
      y="13"
      width="25"
      height="23"
      rx="3"
      stroke="#1261A2"
      strokeWidth="2"
    />

    <path
      d="M11 19H36"
      stroke="#1261A2"
      strokeWidth="2"
    />

    <path
      d="M17 10V16"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M30 10V16"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
    />

    <circle
      cx="31"
      cy="32"
      r="7"
      //fill="#EDF6FD"
      stroke="#1261A2"
      strokeWidth="2"
    />

    <path
      d="M27.5 32L30 34.5L34.5 29.5"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
                </div>

                <div style={textStyle}>
                  Contribuir para a <strong>manutenção das Obras Sociais Irmã Dulce</strong>;
                </div>
              </div>

              {/* ITEM 3 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  padding: '12px 20px',
                  borderBottom: '1px solid #EEF0F3',
                }}
              >
                <div style={iconStyle}>
                <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="12"
      //fill="#EDF6FD"
    />

    <path
      d="M12 37V17"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M12 37H38"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M17 37V29"
      stroke="#1261A2"
      strokeWidth="3"
      strokeLinecap="round"
    />

    <path
      d="M24 37V25"
      stroke="#1261A2"
      strokeWidth="3"
      strokeLinecap="round"
    />

    <path
      d="M31 37V20"
      stroke="#1261A2"
      strokeWidth="3"
      strokeLinecap="round"
    />

    <path
      d="M17 27L23 22L28 24L37 13"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M32 13H37V18"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
                </div>

                <div style={textStyle}>
                  Acompanhar mensalmente as{' '}
                  <strong>realizações e os impactos</strong> gerados;
                </div>
              </div>

              {/* ITEM 4 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  padding: '12px 20px',
                }}
              >
                <div style={iconStyle}>
                <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="12"
      //fill="#EDF6FD"
    />

    <path
      d="M12 17.5V27.5L25 40L39 26L26 13H16.5C14.01 13 12 15.01 12 17.5Z"
      stroke="#1261A2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <circle
      cx="18"
      cy="19"
      r="2.2"
      stroke="#1261A2"
      strokeWidth="2"
    />
  </svg>
                </div>

                <div style={textStyle}>
                  Receber <strong>benefícios exclusivos</strong> nas empresas
                  parceiras.
                </div>
              </div>
            </div>

            {/* SITE */}
            <div

  style={{
    color: '#EAB638',
    fontWeight: 700,
    fontSize: isMobile ? '16px' : '19px',
    marginTop: '25px',
    textAlign: 'center',

  }}
>


  <a
    href="https://clubedosocioprotetor.irmadulce.org.br"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'inline-block',
      marginTop: '8px',
      color: '#1261A2',
      fontWeight: 700,
      fontSize: isMobile ? '15px' : '17px',
      textDecoration: 'none',
      cursor: 'pointer',
    }}
  >
    Saiba mais e acesse →
  </a>
  <div>
    clubedosocioprotetor.irmadulce.org.br
  </div>
</div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

/* =====================================================
   ESTILOS DOS ÍCONES E TEXTOS
===================================================== */

const iconStyle: React.CSSProperties = {
  width: '30px',
  height: '30px',
  minWidth: '30px',
  borderRadius: '12px',
  //backgroundColor: '#EDF6FD',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1261A2',
  fontSize: '26px',
  fontWeight: 700,
};

const textStyle: React.CSSProperties = {
  color: '#444',
  fontSize: '16px',
  lineHeight: 1.35,
  fontFamily: 'Arial, sans-serif',
};

export default Termo;
